export const s3Config = {
    bucketName:  'warroom-media',
    // dirName: 'note-uploaded',      /* Optional */
    region: 'ap-southeast-1',
    accessKeyId:'AKIATBMGY66CFURYEUK3',
    secretAccessKey: '5aVEujphpp1uXC+f+lZeYdlIhsio2XqBECaiPU7f',
    // s3Url: 'https:/your-aws-s3-bucket-url/'     /* Optional */
}